import { useTranslation } from 'react-i18next'
import { TotalEmissionsScope2Type } from '@/hooks'
import { RadioOptionPicker } from '../../../../components/common/Form/RadioOptionPicker/RadioOptionPicker'
import { Option } from '../../../../components/common/Form/types'

export const Scope2TypeSelect: React.FC<{
    value: TotalEmissionsScope2Type
    onChange: (type: TotalEmissionsScope2Type) => void
    isMarketBasedScope2Available?: boolean
}> = (props) => {
    const { t } = useTranslation('translations')
    const { value, onChange, isMarketBasedScope2Available = true } = props

    const options: Array<Option<TotalEmissionsScope2Type>> = [
        {
            value: 'locationBased',
            label: t(
                'sustainability.electricity_mix_usage.scope2Type.location.label'
            ),
            subtitle: t(
                'sustainability.electricity_mix_usage.scope2Type.location.subtitle'
            ),
        },
        {
            value: 'marketBased',
            label: t(
                'sustainability.electricity_mix_usage.scope2Type.market.label'
            ),
            subtitle: t(
                'sustainability.electricity_mix_usage.scope2Type.market.subtitle'
            ),
            disabled: !isMarketBasedScope2Available,
        },
    ]

    return (
        <RadioOptionPicker
            name="scope2-type"
            label={t('sustainability.electricity_mix_usage.scope2Type.label')}
            description={
                <div className="text-body-small text-subtle">
                    {t(
                        'sustainability.electricity_mix_usage.scope2Type.description'
                    )}
                </div>
            }
            value={value}
            options={options}
            onChange={(newValue: string) => {
                onChange(newValue as TotalEmissionsScope2Type)
            }}
            renderLabel={(option) => (
                <div className="flex flex-col">
                    <div className="text-label-small text-regular">
                        {option.label}
                    </div>
                    {option.subtitle && (
                        <div className="text-body-small font-normal text-subtle">
                            {option.subtitle}
                        </div>
                    )}
                </div>
            )}
        />
    )
}
